import React, { useContext, useEffect, useState } from 'react'
import { Roles } from 'utils/enums'
import { UpdateFormContainer } from 'components/admin/Forms/UpdateFormContainer'
import Table from 'components/common/Table'
import * as Yup from 'yup'
import TableButton from 'components/common/Buttons/TableButton'
import { AdminDataContext } from 'context/AdminDataContext'
import Calls from '../Calls'

const TranslatorsSection = ({
  title,
  endpoint,
  disableAutoScroll,
  ownerId,
  getColumnForDeleting,
}) => {
  const { mediators, translators } = useContext(AdminDataContext)

  const [selectedTranslator, setSelectedTranslator] = useState(null)
  const [translatorToModify, setTranslatorToModify] = useState(null)

  const referenceFields = {
    [Roles.Client.role]: [
      {
        data: mediators,
        fieldName: 'mediatorId',
        validation: Yup.string().required('Obligatorio'),
      },
    ],
    get [Roles.Translator.role]() {
      return this[Roles.Client.role]
    },
  }
  const aditionalColumns = [
    {
      Header: 'Llamadas',
      // accessor only gets called when mounting.
      Cell: ({
        row: {
          original: { id, email, calls },
        },
        cellCustomData,
      }) => {
        return (
          <TableButton
            selected={id === cellCustomData.selectedTranslator?.id}
            clickHandler={() => {
              setSelectedTranslator((ps) =>
                ps?.id === id
                  ? null
                  : {
                    title: email,
                    endpoint: calls,
                    id,
                  })
            }}
          >
            Ver Llamadas
          </TableButton>
        )
      },
    },
    {
      Header: 'Editar',
      Cell: ({ row: { original }, cellCustomData }) => {
        return (
          <TableButton
            selected={original.id === cellCustomData.translatorToModify?.id}
            clickHandler={() =>
              setTranslatorToModify((ps) =>
                ps?.id === original.id
                  ? null
                  : { ...original, mediatorId: ownerId || original.mediatorId })}
          >
            Editar
          </TableButton>
        )
      },
    },
    getColumnForDeleting(Roles.Translator.mainPath),
  ]

  useEffect(() => {
    setSelectedTranslator(null)
  }, [endpoint])

  return (
    <>
      <Table
        key={ownerId || endpoint}
        endpoint={endpoint}
        tableData={
          ownerId
            ? translators.filter((c) => c.mediatorId === ownerId)
            : translators
        }
        title={title}
        aditionalColumns={aditionalColumns}
        searchOptions={TRANSLATOR_SEARCH_OPTIONS}
        orderOptions={TRANSLATOR_ORDER_OPTIONS}
        cellCustomData={{ selectedTranslator, translatorToModify }}
        disableAutoScroll={disableAutoScroll}
      >
        {selectedTranslator && (
          <Calls
            endpoint={selectedTranslator.endpoint}
            title={`Llamadas de ${selectedTranslator.title}`}
            columnsToSkip={CALLS_COLUMNS_TO_SKIP}
          />
        )}
      </Table>
      {translatorToModify && (
        <UpdateFormContainer
          referenceFields={referenceFields}
          roleObject={Roles.Translator}
          initialValues={translatorToModify}
          setSelectedUser={setTranslatorToModify}
        />
      )}
    </>
  )
}

const TRANSLATOR_SEARCH_OPTIONS = [
  'email',
  'firstName',
  'lastName',
  'speciality',
]
const TRANSLATOR_ORDER_OPTIONS = [
  'email',
  'speciality',
  'firstName',
  'lastName',
]

const CALLS_COLUMNS_TO_SKIP = ['translatorEmail']

export default TranslatorsSection
